export default __webpack_public_path__ + "static/media/baseline-battery_20-24px.9eb9fce2.svg";